export default window.WR.config;
